import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Chest from '../chest';
import './index.css';
import { getPropertyValueInPixels, isSmartPhone } from '../../utilities/helper';
import constants from '../../constants';
import { allLevelsMockData } from '../../constants/milestones';
import useTheme from '../../utilities/hooks/theme';

function XpLevels() {
  const [selectedChestReward, setSelectedChestReward] = useState('');
  const allLevels = allLevelsMockData;
  const userLevel = useSelector((state: any) => state.user?.userLevel);
  let { themeType = '' } = useSelector((state: any) => state.setting);

  const { AccountTheme: theme } = useTheme();

  useEffect(() => {
    if (userLevel > 1 && allLevels.length) {
      const li = document.querySelector('.chest__wrapper ') as HTMLLIElement;
      const completeWidth =
        getPropertyValueInPixels(li, 'width') + getPropertyValueInPixels(li, 'margin-left') * 2;
      const offSet =
        getPropertyValueInPixels(li, 'border-left') + getPropertyValueInPixels(li, 'margin-left');

      const scrollPixels = completeWidth * (userLevel - 1) + offSet;

      const container = document.getElementById('xpLevels__scroll') as HTMLInputElement;
      container.scroll({
        left: scrollPixels,
        behavior: 'smooth'
      });
    }
  }, [userLevel, allLevels]);

  const slide = (direction: string) => {
    var container = document.getElementById('xpLevels__scroll') as HTMLInputElement;

    const scrollPixels =
      getPropertyValueInPixels(container, 'width') -
      getPropertyValueInPixels(container, 'padding-left') -
      getPropertyValueInPixels(container, 'padding-right');
    const currentPosition = container.scrollLeft;

    if (direction == 'left') {
      container.scroll({
        left: currentPosition - scrollPixels,
        behavior: 'smooth'
      });
    } else {
      container.scroll({
        left: scrollPixels + currentPosition,
        behavior: 'smooth'
      });
    }
  };

  const xpLevelBackdropStyle = {
    backgroundColor: theme.dailyRewardsChestWrapperBg,
    border: `1px solid ${theme.dailyRewardsChestWrapperBorder}`
  };

  return (
    <div className={isSmartPhone ? 'xpLevels__mWeb' : 'xpLevels'}>
      <div className="row g-0">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
          <div className={`${isSmartPhone ? 'xpLevels_wrapper' : ' xpLevels_wrapper_desktop'}`}>
            <div className="xpLevels_backdrop" style={xpLevelBackdropStyle}></div>
            <div className="xpLevels_innerWrapper">
              {!isSmartPhone && (
                <>
                  <img
                    className="xpLevels_Arrow xpLevels_leftArrow"
                    alt="left"
                    src={
                      themeType !== 'dark'
                        ? constants.Images.chestLeftArrow
                        : constants.Images.chestLeftArrowDark
                    }
                    onClick={() => slide('left')}
                  />
                  <img
                    className="xpLevels_Arrow xpLevels_rightArrow"
                    alt="right"
                    src={
                      themeType !== 'dark'
                        ? constants.Images.chestRightArrow
                        : constants.Images.chestRightArrowDark
                    }
                    onClick={() => slide('right')}
                  />
                </>
              )}
              <ul id="xpLevels__scroll" className="xpLevels_list">
                {allLevels?.map((item: any, index: number) => (
                  <Chest
                    allLevels={allLevels}
                    key={item?.id}
                    item={item}
                    index={index}
                    setSelectedChestReward={setSelectedChestReward}
                  />
                ))}
              </ul>

              <p className="xpLevels__rewardInfo">
                <span>
                  {!selectedChestReward ? (
                    <>
                      Scroll and select a treasure chest <br /> to see what is inside
                    </>
                  ) : (
                    selectedChestReward
                  )}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default XpLevels;
